import React, { useState } from "react";
import "./services.css";
import {
  School,
  Heart,
  Briefcase,
  Play,
  Activity,
  MessageCircle,
  Users,
  Brain,
  ChevronDown,
  ChevronUp,
  Leaf,
  Music,
  Bike,
  Drumstick,
  FlowerIcon,
  MoveHorizontal,
} from "lucide-react"; // npm install lucide-react

import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaLaptop,
  FaHeartbeat,
  FaLightbulb,
  FaChild,
  FaUsers,
  FaLeaf,
  FaHandsHelping,
  FaHome,
  FaChalkboardTeacher,
  FaBrain,
  FaBullhorn,
} from "react-icons/fa"; // Import needed icons
import specialeducation from "../../Images/SpecialEducation.JPG";
import Speechtherapy from "../../Images/speechtherapy.jpg";
import occupational from "../../Images/Occupational.jpg";
import physiotherapy from "../../Images/physiotherapy.jpg";
import development from "../../Images/Developement.jpg";
import yoga from "../../Images/yoga.jpg";
import horti from "../../Images/Horticulture.jpg";
import counselling from "../../Images/couselling.jpg";
import matru from "../../Images/Matrudeepti.jpg";
import Sports from "../../Images/Sports.jpg";
import dance from "../../Images/dance.jpg";
import band from "../../Images/Banner6.jpg";
import cdc from "../../Images/cdc.jpg";
import hydrotherapy from "../../Images/Hydrotherapy.jpg";
import behaviour from "../../Images/Behaviour.jpg";
import Montessori from "../../Images/montessori.jpg";
import agriculture from "../../Images/Agriculture.jpg";
import vocational from "../../Images/Vocational.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import staff from "../../Images/staff.jpg";
import music from "../../Images/music.jpg";
import curriculam from "../../Images/Curriculum.jpg";
import computer from "../../Images/computer.jpg";
import physiogym from "../../Images/physiogym.jpg";
import sensory from "../../Images/sensory.jpg";
import developmental from "../../Images/Developement.jpg";
import guidance from "../../Images/Guidance.jpg";
import awareness from "../../Images/Awareness.jpg";
import homevisit from "../../Images/Homevisit.jpg";
import nallapadam from "../../Images/good.jpg";

const DeeptiServices = () => {
  const [expandedService, setExpandedService] = useState(null);
  const [expandedActivity, setExpandedActivity] = useState(null);
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Helper function to get truncated text for cards
  const getShortText = (text, limit = 100) => {
    if (text.length <= limit) return text;
    return text.slice(0, limit) + "...";
  };

  const toggleService = (id) => {
    setExpandedService(expandedService === id ? null : id);
  };

  const toggleActivity = (id) => {
    setExpandedActivity(expandedActivity === id ? null : id);
  };

  const services = [
    {
      id: 1,
      title: "Special Education",
      image: specialeducation,
      icon: <School className="service-icon blue" />,
      description:
        "Special education is customized instruction designed to meet the unique needs of children with disabilities. It uses individualized educational programs (IEPs), specialized materials, and tailored teaching methods to support students with physical, mental, emotional, or learning challenges. The focus is on helping them achieve their potential and prepare for independent living through child-centered, functional, and activity-based learning. Students are grouped by developmental level, from Care group to Vocational, and taught using a mix of one-on-one sessions, group work, and digital tools. Emphasis is placed on daily living skills, core academic areas, and preparation for key exams like Class 10 and +2. Teachers work closely with parents, providing regular updates and home-learning strategies, while also collaborating with therapists, social workers, and school staff to support each student's academic, social, and emotional growth.",
    },
    {
      id: 2,
      title: "Physiotherapy",
      image: physiotherapy,
      icon: <Heart className="service-icon red" />,
      description:
        "At Deepti, physiotherapy is provided for children with cerebral palsy by a dedicated team of qualified physiotherapists. Each child receives a personalized program focused on balance, strength, and coordination using games, equipment, and exercises to reduce spasticity and promote normal movement. Therapists guide families in supporting their child's daily activities and recommend suitable equipment like splints or gaitors. Working closely with other professionals, they ensure holistic care and refer to external specialists when needed. Deepti's modern physiotherapy center is well-equipped and also hosts training sessions led by experts in the field.",
    },
    {
      id: 3,
      title: "Speech and Language Therapy",
      image: Speechtherapy,
      icon: <Briefcase className="service-icon green" />,
      description:
        "Deepti Centre has a well established Department of Speech and Language Therapy. The Department's service is very helpful and essential for the all round progress of the children at Deepti. Speech Therapy is given to students with speech, language and communication impairments. It increases the level of children's confidence for verbal communication. The main focus is to improve their comprehension and expression of the lexical items, vocabulary, functional communication skills, articulation and speech intelligibility of the children. Goals are set based on the level of performance of each child. Through individual and group therapy sessions, significant improvement in vocabulary and comprehension has been observed in most of the children.",
    },
    {
      id: 4,
      title: "Occupational Therapy",
      image: occupational,
      icon: <Play className="service-icon purple" />,
      description:
        "Occupational Therapy is given to children who have difficulties with the practical and social skills. It targets challenges in gross motor skills (e.g., walking, jumping), fine motor skills (e.g., hand dexterity), sensory integration, and self-care tasks (daily dressing, feeding, grooming and hygienic tasks). Occupational Therapy is delivered individually and in groups, using diverse resources like peg boards, play dough, and soft toys. Experts regularly visit to supervise activities and conduct seminars for staff and parent",
    },
    {
      id: 5,
      title: "Developmental Therapy",
      image: development,
      icon: <Activity className="service-icon amber" />,
      description:
        "Developmental therapy supports children with developmental delays by addressing cognitive, social, emotional, and physical needs, focusing on early childhood (birth to 6 years). The centre offers assessment, diagnosis, and individualized interventions. Therapists use standardized tools to evaluate development and create play-based activities to build skills and confidence. Working alongside Speech, Physio, and Occupational therapists under specialist guidance, they also provide home training for parents and pre-academic skill training for children aged 3 to 6 years.",
    },
    {
      id: 6,
      title: "Hydrotherapy",
      image: hydrotherapy,
      icon: <MessageCircle className="service-icon cyan" />,
      description:
        "Hydrotherapy at Deepti involves guided exercises in a safe, clean pool, especially benefiting children with Cerebral Palsy, Autism, and sensory integration issues. The warm water relaxes muscles, reduces spasticity, and supports movement in stiff joints. Play in water boosts concentration, behaviour, and muscle strength. For children with Autism, hydrotherapy encourages social bonding, reduces repetitive behaviors, and improves sensory processing. Sessions are supervised by experienced physiotherapists and support staff in a calming environment.",
    },
    {
      id: 7,
      title: "Behavioural Therapy",
      image: behaviour,
      icon: <Users className="service-icon pink" />,
      description:
        "Behavioural therapy aims to identify and change undesirable behaviours in children, especially those with Autism and ADHD, by replacing them with healthier alternatives. This therapeutic approach employs various techniques to encourage positive behaviour change by focusing on current behaviours and the understanding that learned behaviours can be unlearned. Deepti offers this therapy, guided by a trained behavioural therapist with a postgraduate degree in Psychology.",
    },
    {
      id: 8,
      title: "Yoga Therapy",
      image: yoga,
      icon: <Brain className="service-icon orange" />,
      description:
        "Yoga therapy at Deepti promotes mind-body harmony through postures, breathing, and relaxation, enhancing strength, focus, and emotional expression. It supports balance, co-ordination, sensory processing, and immunity while addressing issues like indigestion and sleep disorders. For children with special needs, it reduces muscle tone in Cerebral Palsy, improves social and motor skills in Autism, boosts focus in ADHD, and aids memory in Dyslexia. Overall, it offers a holistic developmental approach.",
    },
    {
      id: 9,
      title: "Horticultural Therapy",
      image: horti,
      icon: <Brain className="service-icon orange" />,
      description:
        "Horticultural Therapy involves the use of plants and gardening as tools to promote healing and rehabilitate people with special needs. The benefits include improved physical and motor skills, sensory stimulation, cognitive function, emotional regulation, and enhanced social and communication skills.",
    },
    {
      id: 10,
      title: "Vocational Training",
      image: vocational,
      icon: <Brain className="service-icon orange" />,
      description:
        "Deepti provides vocational training for young adults with special needs who are above eighteen years. It has registration under the ministry of social justice. Deepti Vocational Training Centre gives training in Computer education in collaboration with AMBA computer Centre Bangalore, with a special focus on Data entry, and with an aim to prepare them for job. Other activities include training in making door mats, paper bags, jewelry, detergents, candle, agriculture and cooking.",
    },
    {
      id: 11,
      title: "Montessori and Pre School",
      image: Montessori,
      icon: <Brain className="service-icon orange" />,
      description:
        "Little Flower Montessori and Preschool thrives on inclusive education. The Montessori method of education focuses on the natural development of the child, where hands-on learning and character development are the mainstays of teaching and learning. In Montessori schools, children are actively encouraged to explore, play, and learn alongside their peers through activities that stimulate autonomy, challenge, creativity and mastery. Divisions: Tender Heart (Age 2-3 yrs), Nursery (Age 3-4 yrs), LKG (Age 4-5 yrs), UKG (Age 5-6 yrs).",
    },
    {
      id: 12,
      title: "Deepti Child Development Centre",
      image: cdc,
      icon: <Brain className="service-icon orange" />,
      description:
        "Deepti Child Development Centre started on May 15, 2024. A multi-disciplinary team is working to assess, diagnose and intervene in cases of children with milestone delays, speech delay, attention disorder, ASD and ADHD. Therapies such as Physio, Speech, Behavioural and Developmental are provided. Creative Play, Special Education and Specialist Doctor's consultation are available.",
    },
    {
      id: 13,
      title: "Counselling and Guidance",
      image: counselling,
      icon: <Brain className="service-icon orange" />,
      description:
        "Caring for a child with special needs creates chronic physical, financial, and emotional strain for parents, often compounded by social stigma and isolation. The diagnosis can shatter dreams, leading to negative emotions, self-doubt, and anxiety about the future. Deepti provides counselling and guidance for children and their families facing these mental and psychological challenges. Professional counselors offer support to alleviate parental stress, facilitate learning from experienced parents, and conduct counselling seminars led by experts.",
    },
    {
      id: 14,
      title: "Mathrudeepti",
      image: matru,
      icon: <Brain className="service-icon orange" />,
      description:
        "Mathrudeepti is a fellowship of mothers at Deepti who come together, share their experience and successes in improving their children's progress, and encourage one another during challenges. The group arranges various training programs and recreational activities specifically for mothers.",
    },
  ];

  const extraCurricularActivities = [
    {
      id: 1,
      title: "Sports",
      icon: <Bike className="activity-icon blue" />,
      image: Sports,
      description:
        "Under the guidance of a Physical Educator, Deepti provides training in sports and athletics. This enhances physical strength and confidence as well as improves resilience. Children participate in events such as running, shot put, long jump, walking, football, and badminton. Selected children are also taught cycling. Recently, Deepti hosted the Rev. Dr. TG. Koshy Memorial Pathanamthitta District Special School Athletic meet comprising 18 special schools at Kodumon Panchayath stadium, aspiring to represent Team India at the World Paralympics.",
    },
    {
      id: 2,
      title: "Music",
      icon: <Music className="activity-icon purple" />,
      image: music,
      description:
        "Music therapy offers significant cognitive and emotional benefits for differently-abled children. Engaging with music stimulates cognitive skills like memory and attention, while also providing a non-verbal outlet for emotional expression and regulation. Group music activities foster social interaction and communication, and playing instruments improves motor skills. At Deepti, children receive training in vocal and instrumental music (Keyboard and Drums) guided by a dedicated music teacher.",
    },
    {
      id: 3,
      title: "Dance",
      icon: <MoveHorizontal className="activity-icon pink" />,
      image: dance,
      description:
        "Dance promotes overall physical fitness, flexibility, and strength. It also boosts confidence, self-esteem, and serves as a creative outlet that relieves stress. At Deepti, a skilled dance teacher guides children through routines that have won recognition at various events, including a performance opportunity on Flowers TV.",
    },
    {
      id: 4,
      title: "Band",
      icon: <Drumstick className="activity-icon amber" />,
      image: band,
      description:
        "Deepti has a vibrant band team being trained under a professional band master. The band has performed at numerous special programmes not only at the school but also at external events celebrating special occasions.",
    },
    {
      id: 5,
      title: "Agriculture and Gardening",
      icon: <FlowerIcon className="activity-icon green" />,
      image: agriculture,
      description:
        "Deepti provides training in agriculture and gardening under the supervision of an Agricultural Officer. The school practices organic farming and, during 2024-25, bagged the Best School Garden Award for growing marigold during the Onam season. The school also received an award for best agricultural practices in the Pathanamthitta District.",
    },
  ];

  const approaches = [
    {
      id: 1,
      title: "Child-Centered",
      icon: <Leaf className="approach-icon green" />,
      description:
        "Customized programs that adapt to each child's unique needs and developmental pace.",
    },
    {
      id: 2,
      title: "Holistic Development",
      icon: <Activity className="approach-icon purple" />,
      description:
        "Addressing physical, mental, emotional, and social aspects for comprehensive growth.",
    },
    {
      id: 3,
      title: "Family Support",
      icon: <Users className="approach-icon amber" />,
      description:
        "Providing guidance and resources to families to ensure continuous care and progress.",
    },
  ];

  const features = [
    {
      title: "Qualified & Committed Staff",
      icon: <FaChalkboardTeacher />,
      image: staff,
      description:
        "Rehabilitation Council of India registered special educators, BEd/DEd in special education (Intellectual disability (ID), Autism, Learning disability), Physiotherapists, Occupational therapist, Speech and Language therapists, Behavioural therapist, Developmental Therapist and Psychologist.",
    },
    {
      title: "Innovative Curriculum",
      icon: <FaLightbulb />,
      image: curriculam,
      description:
        "Our curriculum is based on the SCERT syllabus tailor made for Care group, Pre-primary, Primary, Secondary, Pre-vocational.  Activity-Based Learning (ABL) and Practical Exposure for Children with Special Needs is an approach that emphasizes learning by doing, engaging multiple senses, and adapting to diverse learning styles. This method is especially effective for children with special needs because it can be tailored to individual strengths and challenges.",
    },
    {
      title: "Computer Class",
      icon: <FaLaptop />,
      image: computer,
      description:
        "We provide training on Information and Communication Technology (ICT) and Data Entry in collaboration with AMBA Computer Training Institute, Bangalore. Deepti is  an AMBA Certified Partner Center (ACPC).",
    },
    {
      title: "Well-equipped Physio Gym",
      icon: <FaHeartbeat />,
      image: physiogym,
      description:
        "Deepti has a state of art physiotherapy centre, with essential equipment such as physio ball, parallel bar, steps, wall ladder, special walkers, special seating systems, standing frames, static cycle, trampoline, treadmill and vibrator etc.  Deepti also provides staff training with the help of experts in the fields of physiotherapy including volunteering professionals from abroad. We provide physiotherapy for children with cerebral palsy and developmental delay, muscle coordination.",
    },
    {
      title: "Sensory Gym",
      icon: <FaBrain />,
      image: sensory,
      description:
        "The activities in a sensory gym help the children with Autism and ADHD to improve their sensory and processing skills. Our sensory gym is equipped with various tools such as a Rotating strobe, Texture mat, Infinity mirror, Corner station, Flexi mirror, Laser projector, Rain wheel rotation, Music station, Therapy swing, Ball pool, Sand play, Messy Play and Therapy ball.",
    },
    {
      title: "Developmental Therapy",
      icon: <FaChild />,
      image: developmental,
      description:
        "Our developmental therapy sessions aim to improve a child's overall development and well-being by addressing specific areas of need, like motor skills, communication, and social-emotional skills.",
    },
    {
      title: "Guidance and Support for Parents",
      icon: <FaHandsHelping />,
      image: guidance,
      description:
        "We provide guidance to parents on Disability Certificate, UDID card (Unique Disability ID Card), Panchayat pension scheme, Social Justice schemes (Niramaya Health Insurance Scheme, Scholarship for Children with disability, Schemes for providing Assistive Devices for people with disabilities, Swasraya scheme), etc.",
    },
    {
      title: "Awareness Programmes",
      icon: <FaBullhorn />,
      image: awareness,
      description:
        "We provide community awareness related to disability and current social issues and awareness for parents of children with disability.",
    },
    {
      title: "Home based Rehabilitation Services",
      icon: <FaHome />,
      image: homevisit,
      description:
        "Our therapists visit bedridden children and young adults with special needs for providing therapy and special education.",
    },
    {
      title: "Agriculture & Nature Care",
      icon: <FaLeaf />,
      image: agriculture,
      description:
        "Horticultural therapy involves the use of plants and gardening as tools to promote healing and rehabilitate people with special needs. The benefits of horticulture therapy includes improved physical and motor skills, sensory stimulation, cognitive function, emotional regulation, and also helps to improve their social and communication skills.",
    },
    {
      title: "Nallapaadam Activities",
      icon: <FaUsers />,
      image: nallapadam,
      description:
        "These are initiatives promoted by Malayala Manorama to encourage social and cultural engagement in schools that promote good practices among the students. Deepti Special School got A+ grade for its 'nallapaadam' activities for the last 8 years consequently. Major activities include distribution of lunch, distribution of food packets for financially challenged families, building houses for the needy, other charitable works for imparting virtues such as compassion, and love towards others.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="deepti-services">
      <header className="header">
        <div className="container">
          <h1 className="deepthi-services-header">SERVICES WE PROVIDE</h1>
        </div>
      </header>

      <main className="container">
        <section className="services-section">
          <div className="services-grid">
            {services.map((item,index) => (
              <div key={index} className="px-3">
              <Card className="h-100 d-flex flex-column shadow-sm border-0">
                <Card.Img
                  variant="top"
                  src={item.image}
                  alt={item.title}
                  className="img-fluid"
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="fw-bold">{item.title}</Card.Title>
                  <Card.Text>
                    {expanded[index]
                      ? item.description
                      : getShortText(item.description, 100)}
                  </Card.Text>
                  <Button
                    variant="link"
                    className="p-0 align-self-start"
                    onClick={() => toggleReadMore(index)}
                  >
                    {expanded[index] ? "Read Less" : "Read More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
              // <div key={service.id} className="service-card">
              //   {/* 🖼️ Image at the top */}
              //   <div className="service-image">
              //     <img
              //       className="services-serviceimg"
              //       src={service.image}
              //       alt={service.title}
              //     />
              //   </div>

              //   {/* 🔤 Title and Icon */}
              //   <div
              //     className="service-header"
              //     onClick={() => toggleService(service.id)}
              //   >
              //     <div className="service-title">
              //       <div className="icon-bg">{service.icon}</div>
              //       <h3>{service.title}</h3>
              //     </div>
              //     {expandedService === service.id ? (
              //       <ChevronUp className="chevron" />
              //     ) : (
              //       <ChevronDown className="chevron" />
              //     )}
              //   </div>

              //   {/* 🔽 Toggle Content */}
              //   <div
              //     className={`service-content ${
              //       expandedService === service.id ? "active" : ""
              //     }`}
              //   >
              //     <p>{service.description}</p>
              //   </div>
              // </div>
            ))}
          </div>
        </section>

        {/* Extra-Curricular Activities Section */}
        <section className="extra-curricular-section">
          <h2 className="extra-curricular">Extra-Curricular Activities</h2>
          <p className="activities-intro">
            At Deepti, we believe in nurturing the complete development of every
            child through engaging and enriching extra-curricular activities
            that build confidence, foster creativity, and develop important life
            skills.
          </p>

          <div className="activities-grid">
            {extraCurricularActivities.map((item,index) => (
              <div key={index} className="px-3">
              <Card className="h-100 d-flex flex-column shadow-sm border-0">
                <Card.Img
                  variant="top"
                  src={item.image}
                  alt={item.title}
                  className="img-fluid"
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="fw-bold">{item.title}</Card.Title>
                  <Card.Text>
                    {expanded[index]
                      ? item.description
                      : getShortText(item.description, 100)}
                  </Card.Text>
                  <Button
                    variant="link"
                    className="p-0 align-self-start"
                    onClick={() => toggleReadMore(index)}
                  >
                    {expanded[index] ? "Read Less" : "Read More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
              // <div key={activity.id} className="activity-card">
              //   {/* Image Section - moved to top */}
              //   <div className="activity-image">
              //     <img
              //       className="services-serviceimg"
              //       src={activity.image}
              //       alt={activity.title}
              //     />
              //   </div>

              //   {/* Header - moved below the image */}
              //   <div
              //     className="activity-header"
              //     onClick={() => toggleActivity(activity.id)}
              //   >
              //     <div className="activity-title">
              //       <div className="icon-bg">{activity.icon}</div>
              //       <h3>{activity.title}</h3>
              //     </div>
              //     {expandedActivity === activity.id ? (
              //       <ChevronUp className="chevron" />
              //     ) : (
              //       <ChevronDown className="chevron" />
              //     )}
              //   </div>

              //   {/* Content */}
              //   <div
              //     className={`activity-content ${
              //       expandedActivity === activity.id ? "active" : ""
              //     }`}
              //   >
              //     <p>{activity.description}</p>
              //   </div>
              // </div>
            ))}
          </div>
        </section>

        {/* Our Approach Section */}
        <section className="approach-section">
        <div className="approach-header">
  <p>
    "If a child cannot learn in the way we teach, we must teach in a way the child can learn."
  </p>
</div>

        </section>

        {/* What Makes Us Special Section */}
        <section className="what-makes-us-special py-5 bg-light">
          <Container>
            <h2 className="text-center mb-4">What Makes Us Special?</h2>
            <Slider {...settings}>
              {features.map((item, index) => (
                <div key={index} className="px-3">
                  <Card className="h-100 d-flex flex-column shadow-sm border-0">
                    <Card.Img
                      variant="top"
                      src={item.image}
                      alt={item.title}
                      className="img-fluid"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="fw-bold">{item.title}</Card.Title>
                      <Card.Text>
                        {expanded[index]
                          ? item.description
                          : getShortText(item.description, 100)}
                      </Card.Text>
                      <Button
                        variant="link"
                        className="p-0 align-self-start"
                        onClick={() => toggleReadMore(index)}
                      >
                        {expanded[index] ? "Read Less" : "Read More"}
                      </Button>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </Slider>
          </Container>
        </section>
      </main>
    </div>
  );
};

export default DeeptiServices;
